exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".party-inputs-label{display:inline-block!important;margin-right:5px}.party-selector-container,.party-selector-container .party-selector-container-element{display:inline-block}.party-selector-container .party-selector-container-element .input-search{width:88%;margin-right:30px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/search/FormElements/partySelector/PartySelector.less
 ** module id = 1084
 ** module chunks = 0
 **/